// External Imports
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DropdownMenu, NavBarItem, NavBarSection } from '@lessonnine/design-system.lib';

// Internal Imports
import { selectNavigationText } from '../../../selectors/selectNavigationText.mjs';
import { selectLanguage } from '../../../selectors/selectMatch.mjs';
import { I18n } from '../../I18n/I18n.jsx';
import { NavBarLink } from '../../Link/NavBarLink.jsx';
import { DropdownMenuItem } from '../../Link/DropdownMenuItem.jsx';
import { buildExploreLink } from './buildExploreLink.mjs';
import { createSelectTranslation } from '../../../selectors/createSelectTranslation.mjs';

// Component Definition
function DesktopNavExploreBase({ getTranslation, language, navigationTextObj }) {
  // TODO: we might fix this in the DS in the long term, asked on the slack channel
  const [isLanguageDropdownOpened, setIsLanguageDropdownOpened] = useState(false);
  return (
    // TODO: follow-up whether NavBarSection should be a section tag in the design-system given the naming
    <section aria-label={getTranslation('categories', 'Explore')}>
      <NavBarSection direction="inline">
        {navigationTextObj.categories && navigationTextObj.categories.length > 0
          ? navigationTextObj.categories.map((link) => (
              <NavBarItem key={link.label}>
                <NavBarLink
                  to={buildExploreLink({
                    langCode: language,
                    link,
                    urlPrefix: 'category',
                  })}
                  link={link}
                  key={link.label}
                >
                  {link.label}
                </NavBarLink>
              </NavBarItem>
            ))
          : undefined}
        {navigationTextObj.aboutLanguages && navigationTextObj.aboutLanguages.length > 0 ? (
          <DropdownMenu
            label={<I18n field="languages" defaultText="Languages" />}
            open={isLanguageDropdownOpened}
            onOpenChange={(value) => setIsLanguageDropdownOpened(value)}
          >
            {navigationTextObj.aboutLanguages.map((link) => (
              <DropdownMenuItem
                key={link.label}
                to={buildExploreLink({ langCode: language, link, urlPrefix: 'tags' })}
                onClick={() => setIsLanguageDropdownOpened(false)}
              >
                {link.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenu>
        ) : undefined}
      </NavBarSection>
    </section>
  );
}

DesktopNavExploreBase.propTypes = {
  getTranslation: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- fix when migrating to TS
  navigationTextObj: PropTypes.object.isRequired,
};

const mapStateToProperties = (state) => ({
  getTranslation: createSelectTranslation(state),
  language: selectLanguage(state),
  navigationTextObj: selectNavigationText(state),
});

const withRedux = connect(mapStateToProperties);

const DesktopNavExplore = withRedux(DesktopNavExploreBase);

// Module Exports
export { DesktopNavExplore };
